import React, { useRef } from 'react';
import { ButtonContainer, Button, Wrapper, ModalHeader, Line, TextAndLine, ButtonClear } from './styled';
import { RegistrationService } from 'services/main/endpoints/RegistrationService';
import SignatureCanvas from 'react-signature-canvas';
import { useCookies } from 'react-cookie';
import * as Sentry from '@sentry/react';
import { createSuccessToast } from 'utils/createToast';
import { useMediaQuery } from 'react-responsive';
export const SignatureInput = ({ setToastList, showHeader = false, setSignature }) => {
  const [cookie] = useCookies();
  const signatureCanvas = useRef({});
  const getNewPath = async empresaId => {
    try {
      const usuarioId = cookie.chamadosAccess.userId;
      const response = await RegistrationService.getImagePath({ EmpresaId: empresaId, usuarioId });
      if (response.status === 200) {
        return response.data.assinaturaNewPath;
      }
    } catch (error) {
      console.error('Erro ao obter o novo caminho de mídia:', error);
      Sentry.captureException(error);
    }
  };
  const uploadImage = async (mediaPath, file) => {
    try {
      const token = cookie.authToken;
      const response = await RegistrationService.uploadSignature({
        filePath: mediaPath,
        file,
        token,
      });
      return response.status === 200;
    } catch (error) {
      console.error('Erro ao fazer o upload:', error);
      Sentry.captureException(error);
      return false;
    }
  };

  const handleImageUpload = async (imageData, mediaType, empresaId) => {
    if (imageData && typeof imageData !== 'string') {
      const file = imageData;
      const fileExtension = file.name.split('.').pop();
      const allowedExtensions = ['jpg', 'jpeg', 'png'];
      if (!allowedExtensions.includes(fileExtension.toLowerCase())) {
        createErrorToast(setToastList, `Formato de arquivo não suportado.`);
        return;
      }

      try {
        const mediaPath = await getNewPath(empresaId, mediaType, fileExtension);
        const uploadSuccess = await uploadImage(mediaPath, file);
        if (uploadSuccess) {
          createSuccessToast(setToastList, 'Assinatura adicionada');
          return mediaPath.replace('/uploads/', '');
        } else {
          throw new Error(`Erro ao fazer upload da imagem.`);
        }
      } catch (error) {
        console.error(error.message);
        Sentry.captureMessage(error.message);
        return;
      }
    }
    return imageData;
  };
  const handleClear = () => {
    signatureCanvas.current.clear();
  };
  const base64ToPng = base64Url => {
    let file;
    if (typeof base64Url === 'string' && base64Url.startsWith('data:image/')) {
      const base64WithoutPrefix = base64Url.split(',')[1];
      const binaryData = Uint8Array.from(atob(base64WithoutPrefix), char => char.charCodeAt(0));
      const blob = new Blob([binaryData], { type: 'image/png' });
      file = new File([blob], 'signature.png', { type: 'image/png' });
    } else if (base64Url instanceof Blob) {
      file = new File([base64Url], 'signature.png', { type: 'image/png' });
    } else {
      return base64Url;
    }
    return file;
  };
  const handleSave = async () => {
    const trimmedCanvas = signatureCanvas.current.getTrimmedCanvas();
    const file = base64ToPng(trimmedCanvas.toDataURL('image/png'));
    const empresaId = cookie.companies?.id;
    const path = await handleImageUpload(file, 'Empresas', empresaId);
    setSignature(path);
  };

  const isDesktop = useMediaQuery({ minWidth: 1081 });
  return (
    <Wrapper>
      {showHeader && <ModalHeader>Adicionar Assinatura</ModalHeader>}
      <SignatureCanvas
        ref={signatureCanvas}
        penColor="black"
        canvasProps={{
          width: isDesktop ? 416 : 303,
          height: 240,
          className: 'sigCanvas',
          style: { backgroundColor: ' #F5F3F1', borderRadius: '8px', border: '1px solid #E8E1DE' },
        }}
      />
      <TextAndLine>
        <Line />
        <div>Assine em cima da linha</div>
      </TextAndLine>
      <ButtonContainer>
        <ButtonClear type="button" onClick={handleClear}>
          Limpar
        </ButtonClear>
        <Button type="button" onClick={() => handleSave()}>
          Salvar
        </Button>
      </ButtonContainer>
    </Wrapper>
  );
};
